const MAX_MAPS_URL_LENGTH = 500;

/**
 * https links on google.com/maps (including maps.google.com), maps.app.goo.gl, or goo.gl/maps.
 * Anything else is rejected so an admin cannot store an arbitrary redirect.
 */
export function isAllowedGoogleMapsUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_MAPS_URL_LENGTH) return false;

  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return false;
  }

  if (url.protocol !== 'https:') return false;
  if (url.username || url.password) return false;

  const host = url.hostname.toLowerCase();
  const path = url.pathname;

  if (host === 'maps.app.goo.gl') return path.length > 1;
  if (host === 'goo.gl') return path === '/maps' || path.startsWith('/maps/');
  if (host === 'maps.google.com') return true;
  if (host === 'google.com' || host === 'www.google.com') {
    return path === '/maps' || path.startsWith('/maps/');
  }
  return false;
}
